import { QueryHookOptions, useQuery } from "@apollo/client";
import { useSelector } from "react-redux";

import msCategoryPaths from "web/queries/default/categoryPaths.graphql";

const useCategoryPaths = () => {
  const { token, id: storeId } = useSelector((state) => state.app.storeConfig);

  const optionsQuery: QueryHookOptions = {
    variables: {
      token,
      storeId: +storeId,
    },
    context: {
      clientName: "magento",
    },
    fetchPolicy: "cache-and-network",
  };

  const { data, error, loading } = useQuery<{ msCategoryPaths: string }>(
    msCategoryPaths,
    optionsQuery
  );

  return { data, error, loading };
};

export default useCategoryPaths;
